module.exports = __webpack_public_path__ + "img/broom.7da1bc70.svg";